class BundleAddToCart extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-bundle-add]');
    this.label = this.button?.querySelector('span');
    this.defaultLabel = this.label?.textContent;
    this.button?.addEventListener('click', this.onClick.bind(this));
  }

  showError() {
    if (!this.button || !this.label) return;
    this.button.classList.add('error');
    this.label.textContent = "Couldn't add — try again";
    clearTimeout(this._errorTimeout);
    this._errorTimeout = setTimeout(() => {
      this.button.classList.remove('error');
      this.label.textContent = this.defaultLabel;
    }, 3000);
  }

  onClick(evt) {
    evt.preventDefault();
    if (this.button.classList.contains('loading')) return;

    let items;
    try {
      items = JSON.parse(this.dataset.items || this.button.dataset.items || '[]');
    } catch (e) {
      items = [];
    }
    if (!items.length) return;

    this.button.setAttribute('aria-disabled', true);
    this.button.classList.add('loading');
    this.button.querySelector('.loading__spinner')?.classList.remove('hidden');

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    const body = JSON.stringify({
      items,
      sections: cart ? cart.getSectionsToRender().map((section) => section.id) : [],
      sections_url: window.location.pathname,
    });

    fetch(`${window.routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.error(response.description || response.message);
          this.showError();
          return;
        }

        if (cart) {
          cart.renderContents(response);
        } else {
          window.location = window.routes.cart_url;
        }
      })
      .catch((e) => {
        console.error(e);
        this.showError();
      })
      .finally(() => {
        this.button.removeAttribute('aria-disabled');
        this.button.classList.remove('loading');
        this.button.querySelector('.loading__spinner')?.classList.add('hidden');
      });
  }
}

customElements.define('bundle-add-to-cart', BundleAddToCart);
